const createQuery = () => `
  ... on CompanyPartnershipsWidget {
    id
    isCarousel
    partnerships {
      _id
      name
      slug
      images {
        thumbnail_640 {
          url
        }
      }
    }
  }
`

export default createQuery
